import React from "react";
import { Table } from "reactstrap";
import TableSkeleton from "../Skeleton/TableSkeleton";
import WebsiteIdentityCell from "./WebsiteIdentityCell";
import ComparisonTableCell from "./ComparisonTableCell";

export const PDP_COLUMNS = [
	{ key: "questions", label: "Questions", format: "number", deltaType: "number", positiveIsGood: true, exportable: true },
	{ key: "addToCart", label: "Add to Cart", format: "number", deltaType: "number", positiveIsGood: true, exportable: true },
	{ key: "conversions", label: "Conversion", format: "number", deltaType: "number", positiveIsGood: true, exportable: true },
];

export const SHOPPING_ASSISTANT_COLUMNS = [
	{ key: "conversations", label: "Conversations", format: "number", deltaType: "number", positiveIsGood: true, exportable: true },
	{ key: "productClicks", label: "Product Clicks", format: "number", deltaType: "number", positiveIsGood: true, exportable: true },
	{ key: "addToCart", label: "Add to Cart", format: "number", deltaType: "number", positiveIsGood: true, exportable: true },
	{ key: "conversions", label: "Conversion", format: "number", deltaType: "number", positiveIsGood: true, exportable: true },
];

const AiAssistantAnalyticsTable = ({
	rows = [],
	loading = false,
	onDownloadMetric,
	exportingKey = null,
}) => {
	if (loading && rows.length === 0) {
		return <TableSkeleton />;
	}

	const colSpan = PDP_COLUMNS.length + SHOPPING_ASSISTANT_COLUMNS.length + 1;

	return (
		<div className="platformAnalyticsTableWrapper mt-3">
			<Table className={`table ${rows.length > 0 ? "table-striped" : ""} custom-bordered-table platformAnalyticsTable aiAssistantAnalyticsTable`}>
				<thead>
					<tr>
						<th className="websiteIdentityHeader" rowSpan={2}>
							Company
						</th>
						<th className="metricGroupHeader" colSpan={PDP_COLUMNS.length}>
							PDP
						</th>
						<th
							className="metricGroupHeader metricGroupHeaderShopping"
							colSpan={SHOPPING_ASSISTANT_COLUMNS.length}
						>
							Shopping Assistant
						</th>
					</tr>
					<tr>
						{PDP_COLUMNS.map((col) => (
							<th key={`pdp-${col.key}`} className="metricSubHeader">
								{col.label}
								{col.exportable ? (
									<span className="metricExportHint" title="Click a value to download XLSX">
										{" "}↓
									</span>
								) : null}
							</th>
						))}
						{SHOPPING_ASSISTANT_COLUMNS.map((col) => (
							<th
								key={`sa-${col.key}`}
								className="metricSubHeader metricSubHeaderShopping"
							>
								{col.label}
								{col.exportable ? (
									<span className="metricExportHint" title="Click a value to download XLSX">
										{" "}↓
									</span>
								) : null}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{rows.length === 0 ? (
						<tr>
							<td colSpan={colSpan}>
								<div className="emptyPlaceholder">
									<div>
										<div>
											<img
												src={require("../../assets/images/paper-plane-grey.png")}
												className="img-fluid"
												alt="No data found"
											/>
										</div>
										<div className="rsInfoMsg disabled">
											<div className="flex-1">No records found.</div>
										</div>
									</div>
								</div>
							</td>
						</tr>
					) : (
						rows.map((row) => (
							<tr key={row.websiteId}>
								<WebsiteIdentityCell
									websiteId={row.websiteId}
									websiteUrl={row.websiteUrl}
									companyName={row.companyName}
									reportsPath="/aiassistant/dashboard"
								/>
								{PDP_COLUMNS.map((col) => {
									const metricKey = `pdp.${col.key}`;
									const exportKey = `${row.websiteId}:${metricKey}`;
									return (
										<ComparisonTableCell
											key={`pdp-${col.key}`}
											metric={row.pdp?.[col.key]}
											format={col.format}
											deltaType={col.deltaType}
											positiveIsGood={col.positiveIsGood}
											exportable={Boolean(col.exportable && onDownloadMetric)}
											exporting={exportingKey === exportKey}
											exportLabel={`Download ${col.label} data (XLSX)`}
											onExport={() =>
												onDownloadMetric({
													websiteId: row.websiteId,
													metricKey,
													label: col.label,
												})
											}
										/>
									);
								})}
								{SHOPPING_ASSISTANT_COLUMNS.map((col) => {
									const metricKey = `shoppingAssistant.${col.key}`;
									const exportKey = `${row.websiteId}:${metricKey}`;
									return (
										<ComparisonTableCell
											key={`sa-${col.key}`}
											metric={row.shoppingAssistant?.[col.key]}
											format={col.format}
											deltaType={col.deltaType}
											positiveIsGood={col.positiveIsGood}
											exportable={Boolean(col.exportable && onDownloadMetric)}
											exporting={exportingKey === exportKey}
											exportLabel={`Download ${col.label} data (XLSX)`}
											onExport={() =>
												onDownloadMetric({
													websiteId: row.websiteId,
													metricKey,
													label: col.label,
												})
											}
										/>
									);
								})}
							</tr>
						))
					)}
				</tbody>
			</Table>
		</div>
	);
};

export default AiAssistantAnalyticsTable;
